import { render, staticRenderFns } from "./TemplateSliderSkeleton.vue?vue&type=template&id=77c6a509&scoped=true"
var script = {}
import style0 from "./TemplateSliderSkeleton.vue?vue&type=style&index=0&id=77c6a509&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6a509",
  null
  
)

export default component.exports